<script setup>
import PFBaseModal from "@/components/common/modal/PFBaseModal.vue";
import "@sapudex/web-components/dist/TextField.js";
import "@sapudex/web-components/dist/Button.js";
import { computed } from "vue";
import { useI18n } from 'vue-i18n';

defineOptions({
  name: 'PEProfileEmailModal',
});

const props = defineProps({
  emailValue: {
    type: Function,
    default: () => '',
  },
  changeEmailValue: {
    type: Function,
    default:() => '',
  },
  saveChangeEmail: {
    type: Function,
    default:() => '',
  },
  closeEmailModal: {
    type: Function,
    default:() => '',
  },
  showModal: {
    type: Boolean,
    default: false
  },
  changedErrorEmail: {
    type: Boolean,
    default:false,
  },
  disableSave: {
    type: Boolean,
    default:false,
  },
  changedEmptyEmail: {
    type: Boolean,
    default:false,
  }
});

const { t } = useI18n();

const errorMessage = computed(() => {
  if (!props.changedErrorEmail) return "";
  return props.changedEmptyEmail
    ? t("mandatory.field.error.message")
    : t("local.office.email.error.message");
});

</script>

<template>
<PFBaseModal v-if="showModal" :modalControlKey="'ProfileContactEmailModal'" :modalHeaderText='$t("edit.email.contact")' >
    <div class="body-s-size mb-5">
      {{ $t("edit.email.text") }}
    </div>
    <div>
      <udex-text-field 
        :value="emailValue()"
        value-state="Standard"
        :required="true"
        :label="$t('label.email')"
        :valueState="props.changedErrorEmail  ? 'Error' : ''"
        :supportingText="errorMessage"
        @input="changeEmailValue"
      />
    </div>
    
    <template #buttons>
      <udex-button
        @click="saveChangeEmail()"
        size="Large"
        slot="endContent"
        :disabled=" props.disableSave"
        accessibleName="Edit Contact Email"
      >
        {{ $t('button.done') }}
      </udex-button>

      <udex-button
        @click="closeEmailModal()"
        design="Secondary"
        size="Large"
        slot="endContent"
        accessibleName="Cancel Edit Contact Email"
      >
        {{$t('button.close')}}
      </udex-button>
    </template>
  </PFBaseModal>
</template>